/** @format */

import React, { Component } from 'react';
import { Modal, Form, Icon, Header } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

@inject('RequestsStore', 'ClientsStore', 'SalesStore')
@observer
class LeaveRequestModal extends Component {
  render() {
    const { RequestsStore, ClientsStore, SalesStore } = this.props;
    return (
      <Modal open={RequestsStore.requestsParams.leaveRequestModal.open}>
        <Modal.Content>
          <Header className="modal-header" as="h3">
            Attenzione!!
          </Header>
          <div className="header-spacer"></div>
          <div>
            <p>Tornando indietro perderai tutte le modifiche.</p>
          </div>
          <br />
          <Form
            className="modal-form"
            size="small"
            onSubmit={() => this.formSubmit()}
          >
            <Form.Group widths="equal">
              <Form.Button
                onClick={() => {
                  RequestsStore.toggleLeaveRequestModal();
                  RequestsStore.resetCurrentRequest();
                  ClientsStore.resetCurrentClient();
                  SalesStore.resetCurrentSale();
                  this.props.history.push('/requests');
                }}
                color="red"
                fluid
              >
                <Icon name="cancel" />
                Annulla Modifiche
              </Form.Button>
              <Form.Button
                onClick={() => {
                  RequestsStore.toggleLeaveRequestModal();
                }}
                color="green"
                fluid
              >
                <Icon name="save" />
                Continua Modifica
              </Form.Button>
            </Form.Group>
          </Form>
          <div
            className="close-button"
            onClick={() => {
              RequestsStore.toggleLeaveRequestModal();
            }}
          >
            X
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default withRouter(LeaveRequestModal);
